var counttime = 0;
var myInterval;
function cartNotification(cartId) {
  fetch(window.Shopify.routes.root + "?section_id=quick-cart-notification")
    .then((response) => response.text())
    .then((responseText) => {
      const cnID = "quick-cart-notification";
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const destination = document.querySelector(".cart_popup");
      const source = html.getElementById(cnID);
      if (source && destination) destination.innerHTML = source.innerHTML;
      let lastItem = document.querySelector(
        ".qch_items .cn_" + cartId
      ).innerHTML;
      if (lastItem) document.querySelector(".qch_items").innerHTML = lastItem;
      if (document.querySelector(".quick-cart-notification")) {
        setTimeout(() => {
          document.querySelector(".cart_popup").classList.add("active");
        }, 1000);
      }
      counttime = 0;
      myInterval = setInterval(timer, 1000);
      function timer() {
        counttime++;
        if (counttime > 5) {
          document.querySelector(".cart_popup").classList.remove("active");
          setTimeout(() => {
            document.querySelector(".cart_popup").innerHTML = "";
          }, 3000);
          myStop();
        }
      }
      function myStop() {
        clearInterval(myInterval);
      }
      document.querySelector('.cart-btn').addEventListener('click', function () {
        window.Rebuy.SmartCart.show();
      });
      document.querySelector('.popup-close').addEventListener('click', function () {
        document.querySelector('.cart_popup').classList.remove('active');
        setTimeout(() => {
          document.querySelector('.cart_popup').innerHTML = '';
        }, 300);
      });
      document.body.addEventListener("click", function (e) {
        var popup = document.querySelector(".cart_popup");
        if (!popup.contains(event.target)) {
          popup.innerHTML = "";
          popup.classList.remove("active");
        }
      });
    });
}

document.querySelectorAll('.quick-view-unavailable').forEach(function(el) {
  el.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    const url = el.getAttribute('data-url');
    if (url) {
      window.location.href = url;
    }
  });
});

if(document.querySelectorAll('.quick-view__option')){
  function quickAddButton(){
    document.querySelectorAll('.quick-view__option').forEach(function(sizeList){
      sizeList.addEventListener('click',function(e){
        document.querySelector('.cart_popup').classList.remove('active');
        setTimeout(() => {
          document.querySelector('.cart_popup').innerHTML = '';
        }, 300);
        clearInterval(myInterval);
        e.preventDefault();
        e.stopImmediatePropagation();
        sizeList.classList.add('quick-add-loading');
        // if(window.innerWidth > 991){
          let variant_id = sizeList.dataset.id;
          if(variant_id != undefined){
            let formData = {
              'items': [{
                'id': variant_id,
                'quantity': 1
              }]
            };
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
            })
              
            .then((response) => response.json())
            .then((data) => {
              
              if(document.querySelector('body').classList.contains('rebuy-modal-visible')){
                document.querySelector('body').classList.remove('open-quick-buy');
              }
              const url = '/cart.js';
              fetch(url)
              .then((resp) => resp.json())
              .then(function(data) {
                if (window.innerWidth > 768) {                  
                cartNotification(data.items[0].id);
                }
                var cart_count = data.item_count;
                if(cart_count>0){
                  document.querySelector('.cart-count').innerHTML = cart_count;
                   setTimeout(() => {
                      document.querySelector('.cart-icon-bubble__count').classList.remove('hidden');
                     }, 1000);
                }else{
                  document.querySelector('.cart-count').innerHTML = '';
                }
              })
              .catch(function(error) {
                console.log(error);
              })
              sizeList.classList.remove('quick-add-loading');
              sizeList.classList.add('added-to-cart');
              setTimeout(() => {
                sizeList.classList.remove('added-to-cart');
              }, 3000);
              if (window.innerWidth > 768) {
                // document.addEventListener('rebuy:cart.change', (event) => { 
                //   window.Rebuy.SmartCart.hide();
                // });
                window.Rebuy.SmartCart.skip_open = true;
              }
            })
            .catch((error) => {
              console.error(error);
            });
          }
        // }
        // if (window.innerWidth < 768) {
        //  document.querySelectorAll('.quick-view__option').forEach(function(el) {
        //     el.classList.remove('active');
        //   });
        //   this.classList.add('active');
        // }
      });
    });
    if(document.querySelector('.product-card')) document.querySelectorAll('.product-card').forEach(function(grid_col){
      grid_col.addEventListener('mouseleave', function(){
        if(grid_col.querySelector('.quick-view__option.active')) grid_col.querySelector('.quick-view__option.active').classList.remove('active');
      });
    });
    // document.querySelectorAll('.quick-view-btn a').forEach(function(quick_add){
    //   quick_add.addEventListener('click',function(e){
                    
    //     e.preventDefault();
    //     e.stopImmediatePropagation();
    //     let variant_id = quick_add.closest('.quick-view').querySelector('.quick-view__options .quick-view__option.active').dataset.id;
    //     quick_add.closest('.quick-view-btn').classList.add('quick-add-loading');
    //     console.log('variant_id',variant_id);
    //     if(variant_id != undefined){
    //       let formData = {
    //         'items': [{
    //           'id': variant_id,
    //           'quantity': 1
    //         }]
    //       };

    //       fetch('/cart/add.js', {
    //         method: 'POST',
    //         headers: {
    //           'Content-Type': 'application/json',
    //         },
    //         body: JSON.stringify(formData),
    //       })
            
    //       .then((response) => response.json())
    //       .then((data) => {
    //         e.preventDefault();
    //         if(document.querySelector('body').classList.contains('rebuy-modal-visible')){
    //           document.querySelector('body').classList.remove('open-quick-buy');
    //         }
    //         const url = '/cart.js';
    //         fetch(url)
    //         .then((resp) => resp.json())
    //         .then(function(data) {
    //           if (window.innerWidth > 768) {
    //           cartNotification(data.items[0].id);
    //           }
    //           var cart_count = data.item_count;
    //           if(cart_count>0){
    //             document.querySelector('.cart-count').innerHTML = cart_count;
    //             setTimeout(() => {
    //                   document.querySelector('.cart-icon-bubble__count').classList.remove('hidden');
    //                  }, 1000);
    //           }else{
    //             document.querySelector('.cart-count').innerHTML = '';
    //           }
    //         })
    //         .catch(function(error) {
    //           console.log(error);
    //         })
    //         quick_add.closest('.quick-view-btn').classList.remove('quick-add-loading');
    //         quick_add.closest('.quick-view-btn').classList.add('added-to-cart');
    //         setTimeout(() => {
    //           quick_add.closest('.quick-view-btn').classList.remove('added-to-cart');
    //         }, 3000);
    //         setTimeout(() => {
    //           if (window.innerWidth < 768) {
    //             document.querySelector('body').classList.remove('open-quick-buy');
    //           }
    //         }, 4000);
    //         if (window.innerWidth > 768) {
    //           document.addEventListener('rebuy:cart.change', (event) => { 
    //             window.Rebuy.SmartCart.hide();
    //           });
    //         }
    //       })
    //       .catch((error) => {
    //         console.error(error);
    //       });
    //     }
    //   });
    // });
  }
  quickAddButton();
}